export type EdgeStateName = 'default' | 'hover' | 'pending' | 'reconnect' | 'cut-preview' | 'invalid';

export function edgeKey(fromNode: string, fromPort: number, toNode: string, toPort: number): string {
  return `${fromNode}:${fromPort}:${toNode}:${toPort}`;
}

export interface EdgeVisualStateController {
  getHoveredEdgeKey(): string | null;
  setHoveredEdgeKey(key: string | null): void;
  getDetachPreviewEdgeKey(): string | null;
  setDetachPreviewEdgeKey(key: string | null): void;
  getCutPreviewKeys(): Set<string>;
  setCutPreviewKeys(keys: Iterable<string>): void;
  clearCutPreviewKeys(): void;
  isCuttingEdges(): boolean;
  setCuttingEdges(active: boolean): void;
}

export function createEdgeVisualStateController(): EdgeVisualStateController {
  let hoveredEdgeKey: string | null = null;
  let detachPreviewEdgeKey: string | null = null;
  let cutPreviewKeys = new Set<string>();
  let cuttingActive = false;

  return {
    getHoveredEdgeKey: () => hoveredEdgeKey,
    setHoveredEdgeKey(key): void {
      hoveredEdgeKey = key;
    },
    getDetachPreviewEdgeKey: () => detachPreviewEdgeKey,
    setDetachPreviewEdgeKey(key): void {
      detachPreviewEdgeKey = key;
    },
    getCutPreviewKeys: () => cutPreviewKeys,
    setCutPreviewKeys(keys): void {
      cutPreviewKeys = new Set(keys);
    },
    clearCutPreviewKeys(): void {
      cutPreviewKeys.clear();
    },
    isCuttingEdges: () => cuttingActive,
    setCuttingEdges(active): void {
      cuttingActive = active;
    },
  };
}
